import format from 'date-format'
export const formatDate = (date) => {
  return format.asString('dd/MM/yyyy', new Date(date))
}
